import React from 'react';
import { CheckCircle2, ArrowRight, Download, Layers, Shield, Droplets, Volume2, Flame, Sparkles } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { productTypesData } from '../data/productTypes';
import { API_URL } from '../config';



const ProductsPage = () => {
  const { language } = useLanguage();

  const content = {
    ru: {
      header: {
        title: 'Наша продукция',
        subtitle: 'Гипсовиниловые панели - более технологичная альтернатива устаревшим методам'
      },
      downloadPresentation: 'Скачать презентацию о панелях',
      innovation: {
        label: 'Революция в отделке стен',
        title: 'Инновационный, износостойкий материал с мощным декоративным покрытием из ПВХ',
        features: [
          'Быстрый монтаж - экономия времени до 50%',
          'Влагостойкое декоративное покрытие из ПВХ',
          'Огнестойкая основа с сертификацией',
          'Готовые дизайнерские решения'
        ]
      },
      techSpecs: {
        title: 'Состав панелей GIPSOVINIL.KZ',
        image: 'https://customer-assets.emergentagent.com/job_66ffc534-d196-4241-b6b9-10c457855baf/artifacts/ct5t0dmy_11111-no-bg-HD%20%28carve.png',
        layers: [
          { name: 'Декоративное ПВХ покрытие', desc: '0.3-0.5 мм', icon: 'sparkles' },
          { name: 'Защитный слой', desc: 'UV-стойкий', icon: 'shield' },
          { name: 'Основа ГКЛ/СМЛ', desc: '9.5-12.5 мм', icon: 'layers' }
        ],
        specs: [
          { label: 'Размеры', value: '1200 × 2400 мм', icon: 'layers' },
          { label: 'Толщина', value: '9.5 / 12.5 мм', icon: 'layers' },
          { label: 'Огнестойкость', value: 'КМ1-КМ2, Г1', icon: 'flame' },
          { label: 'Влагостойкость', value: 'до 95% влажности', icon: 'droplets' },
          { label: 'Шумоизоляция', value: '28-40 дБ', icon: 'volume' },
          { label: 'Срок службы', value: '25+ лет', icon: 'shield' }
        ]
      },
      productTypes: productTypesData.ru,
      slides: {
        slide7title: 'Более технологичная альтернатива устаревшим методам',
        slide10title: 'Создаём не просто продукт, а стандарт новой отделки',
        slide11title: 'Гипсовинил — инженерное решение с продуманным дизайном'
      },
      cta: {
        title: 'Готовы выбрать продукцию?',
        subtitle: 'Наши специалисты помогут подобрать оптимальное решение для вашего проекта',
        consultation: 'Получить консультацию',
        catalog: 'Смотреть каталог текстур'
      }
    },
    kz: {
      header: {
        title: 'Біздің өнімдер',
        subtitle: 'Гипсвинил панельдері - ескірген әдістерге қарағанда технологиялық балама'
      },
      downloadPresentation: 'Панельдер туралы презентацияны жүктеу',
      innovation: {
        label: 'Қабырға әрлеуіндегі революция',
        title: 'ПВХ-дан қуатты декоративті жабынмен инновациялық, тозуға төзімді материал',
        features: [
          'Жылдам монтаж - уақытты 50%-ға дейін үнемдеу',
          'ПВХ-дан ылғалға төзімді декоративті жабын',
          'Сертификаты бар өртке төзімді негіз',
          'Дайын дизайнерлік шешімдер'
        ]
      },
      techSpecs: {
        title: 'GIPSOVINIL.KZ панельдерінің құрамы',
        image: 'https://customer-assets.emergentagent.com/job_66ffc534-d196-4241-b6b9-10c457855baf/artifacts/ct5t0dmy_11111-no-bg-HD%20%28carve.png',
        layers: [
          { name: 'Декоративті ПВХ жабын', desc: '0.3-0.5 мм', icon: 'sparkles' },
          { name: 'Қорғаныс қабаты', desc: 'UV-төзімді', icon: 'shield' },
          { name: 'ГКЛ/СМЛ негізі', desc: '9.5-12.5 мм', icon: 'layers' }
        ],
        specs: [
          { label: 'Өлшемдері', value: '1200 × 2400 мм', icon: 'layers' },
          { label: 'Қалыңдығы', value: '9.5 / 12.5 мм', icon: 'layers' },
          { label: 'Өртке төзімділігі', value: 'КМ1-КМ2, Г1', icon: 'flame' },
          { label: 'Ылғалға төзімділігі', value: '95% дейін', icon: 'droplets' },
          { label: 'Шуыл оқшаулау', value: '28-40 дБ', icon: 'volume' },
          { label: 'Қызмет мерзімі', value: '25+ жыл', icon: 'shield' }
        ]
      },
      productTypes: productTypesData.kz,
      slides: {
        slide7title: 'Ескірген әдістерге қарағанда технологиялық балама',
        slide10title: 'Жай ғана өнім емес, жаңа әрлеу стандартын жасаймыз',
        slide11title: 'Гипсовинил — ойластырылған дизайнмен инженерлік шешім'
      },
      cta: {
        title: 'Өнімді таңдауға дайынсыз ба?',
        subtitle: 'Біздің мамандар жобаңыз үшін оңтайлы шешім таңдауға көмектеседі',
        consultation: 'Кеңес алу',
        catalog: 'Текстуралар каталогын көру'
      }
    },
    en: {
      header: {
        title: 'Our Products',
        subtitle: 'Gypsum-vinyl panels - a more technological alternative to outdated methods'
      },
      downloadPresentation: 'Download Panel Presentation',
      innovation: {
        label: 'Revolution in wall finishing',
        title: 'Innovative, wear-resistant material with powerful PVC decorative coating',
        features: [
          'Fast installation - up to 50% time savings',
          'Moisture-resistant PVC decorative coating',
          'Fire-resistant base with certification',
          'Ready-made design solutions'
        ]
      },
      techSpecs: {
        title: 'GIPSOVINIL.KZ Panel Composition',
        image: 'https://customer-assets.emergentagent.com/job_66ffc534-d196-4241-b6b9-10c457855baf/artifacts/ct5t0dmy_11111-no-bg-HD%20%28carve.png',
        layers: [
          { name: 'Decorative PVC coating', desc: '0.3-0.5 mm', icon: 'sparkles' },
          { name: 'Protective layer', desc: 'UV-resistant', icon: 'shield' },
          { name: 'GKL/SML base', desc: '9.5-12.5 mm', icon: 'layers' }
        ],
        specs: [
          { label: 'Dimensions', value: '1200 × 2400 mm', icon: 'layers' },
          { label: 'Thickness', value: '9.5 / 12.5 mm', icon: 'layers' },
          { label: 'Fire resistance', value: 'KM1-KM2, G1', icon: 'flame' },
          { label: 'Moisture resistance', value: 'up to 95% humidity', icon: 'droplets' },
          { label: 'Sound insulation', value: '28-40 dB', icon: 'volume' },
          { label: 'Service life', value: '25+ years', icon: 'shield' }
        ]
      },
      productTypes: productTypesData.en,
      slides: {
        slide7title: 'A more technological alternative to outdated methods',
        slide10title: 'We create not just a product, but a new finishing standard',
        slide11title: 'Gypsovinil — an engineering solution with thoughtful design'
      },
      cta: {
        title: 'Ready to choose products?',
        subtitle: 'Our specialists will help you find the optimal solution for your project',
        consultation: 'Get Consultation',
        catalog: 'View Texture Catalog'
      }
    },
    ar: {
      header: {
        title: 'منتجاتنا',
        subtitle: 'ألواح الجبس الفينيل - بديل تقني متطور عن الأساليب القديمة'
      },
      downloadPresentation: 'تحميل عرض الألواح',
      innovation: {
        label: 'ثورة في تشطيب الجدران',
        title: 'مادة مبتكرة ومقاومة للاهتراء مع طبقة زخرفية PVC عالية الأداء',
        features: [
          'تركيب سريع - توفير يصل إلى 50% من الوقت',
          'طبقة زخرفية PVC مقاومة للرطوبة',
          'قاعدة مقاومة للحريق مع شهادة اعتماد',
          'حلول تصميمية جاهزة'
        ]
      },
      techSpecs: {
        title: 'تركيبة ألواح GIPSOVINIL.KZ',
        image: 'https://customer-assets.emergentagent.com/job_66ffc534-d196-4241-b6b9-10c457855baf/artifacts/ct5t0dmy_11111-no-bg-HD%20%28carve.png',
        layers: [
          { name: 'طبقة زخرفية PVC', desc: '0.3-0.5 مم', icon: 'sparkles' },
          { name: 'طبقة حماية', desc: 'مقاومة للأشعة فوق البنفسجية', icon: 'shield' },
          { name: 'قاعدة GKL/SML', desc: '9.5-12.5 مم', icon: 'layers' }
        ],
        specs: [
          { label: 'الأبعاد', value: '1200 × 2400 مم', icon: 'layers' },
          { label: 'السماكة', value: '9.5 / 12.5 مم', icon: 'layers' },
          { label: 'مقاومة الحريق', value: 'KM1-KM2, G1', icon: 'flame' },
          { label: 'مقاومة الرطوبة', value: 'حتى 95% رطوبة', icon: 'droplets' },
          { label: 'عزل صوتي', value: '28-40 dB', icon: 'volume' },
          { label: 'العمر الافتراضي', value: 'أكثر من 25 عاماً', icon: 'shield' }
        ]
      },
      productTypes: productTypesData.ar,
      slides: {
        slide7title: 'بديل تقني متطور عن الأساليب القديمة',
        slide10title: 'نصنع ليس مجرد منتج، بل معياراً جديداً للتشطيب',
        slide11title: 'Gypsovinil — حل هندسي بتصميم مدروس'
      },
      cta: {
        title: 'هل أنتم مستعدون لاختيار المنتجات؟',
        subtitle: 'سيساعدكم متخصصونا في إيجاد الحل الأمثل لمشروعكم',
        consultation: 'احصل على استشارة',
        catalog: 'عرض كتالوج الأنسجة'
      }
    }
  };

  const t = content[language] || content.en || content.ru;

  return (
    <div className="pt-20 bg-[#061d36]" data-testid="products-page">
      {/* Header */}
      <section className="py-8 pb-16 bg-[#061d36] text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-testid="products-title">{t.header.title}</h1>
          <p className="text-xl text-blue-200 max-w-3xl mx-auto mb-6">
            {t.header.subtitle}
          </p>
          
          {/* Download Presentation Button */}
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href={`${API_URL}/api/docs/prezentaciya-gipsovinil.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-[#8B4444] hover:bg-[#7A3838] text-white rounded-xl font-semibold transition-all shadow-lg hover:shadow-xl"
              data-testid="download-presentation-btn"
            >
              <Download className="w-5 h-5" />
              {t.downloadPresentation}
            </a>
          </div>
        </div>
      </section>

      {/* Product Types */}
      <section className="py-8 bg-[#F5F5F0]">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-[#061d36] text-center mb-12">{t.productTypes.title}</h2>
          <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {t.productTypes.types.map((type, idx) => {
              const getButtonColorClass = (colorClass) => {
                if (colorClass === 'bg-blue-300') return 'bg-blue-300 hover:bg-blue-400 text-[#061d36]';
                if (colorClass === 'bg-[#8b4444]') return 'bg-[#8b4444] hover:bg-[#7a3939] text-white';
                if (colorClass === 'bg-[#061d36]') return 'bg-[#061d36] hover:bg-[#0d2a47] text-white';
                return 'bg-gray-500 text-white';
              };
              return (
                <Link 
                  key={idx} 
                  to={`/products/${type.link}`}
                  className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all group cursor-pointer block"
                  data-testid={`product-card-${type.link}`}
                >
                  <div className={`h-3 ${type.color}`}></div>
                  {type.image && (
                    <div className="px-6 pt-4 flex justify-center">
                      <img src={type.image} alt={type.name} className="h-48 w-auto object-contain" loading="lazy" />
                    </div>
                  )}
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-[#061d36] mb-3 group-hover:text-[#8b4444] transition-colors">{type.name}</h3>
                    <p className="text-[#061d36]/70 mb-4">{type.description}</p>
                    <div className="space-y-2 mb-6">
                      {type.specs.map((spec, i) => (
                        <div key={i} className="flex items-center text-sm text-gray-500">
                          <CheckCircle2 className="w-4 h-4 text-[#061d36] mr-2 flex-shrink-0" />
                          <span className={spec.includes('Класс') || spec.includes('Class') ? 'font-bold text-[#061d36]' : ''}>
                            {spec}
                          </span>
                        </div>
                      ))}
                    </div>
                    <span 
                      className={`inline-flex items-center justify-center px-6 py-3 rounded-full font-medium transition-all ${getButtonColorClass(type.color)}`}
                      data-testid={`product-btn-${type.link}`}
                    >
                      {t.productTypes.more}
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* Innovation & Tech Specs */}
      <section className="py-8 bg-[#F5F5F0]">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {/* Left - Innovation */}
            <div className="bg-[#F5F5F0] rounded-2xl p-8 border-2 border-[#061d36]" data-testid="innovation-card">
              <h2 className="text-2xl font-bold text-[#061d36] uppercase mb-4">{t.innovation.label}</h2>
              <p className="text-xl text-[#061d36] mb-6">
                {t.innovation.title}
              </p>
              <div className="rounded-xl overflow-hidden">
                <img 
                  src="/images/panel_structure.webp" 
                  alt="Структура монтажа панелей" 
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>

            {/* Right - Panel Composition */}
            <div className="bg-[#F5F5F0] rounded-2xl overflow-hidden p-6 border-2 border-[#061d36]" data-testid="panel-composition-card">
              <h3 className="text-2xl font-bold text-[#061d36] mb-2 text-center">{t.techSpecs.title}</h3>
              <p className="text-[#061d36]/70 text-sm mb-6 text-center">{t.techSpecs.subtitle}</p>
              
              {/* Panel Image */}
              <div className="flex justify-center items-center mb-6">
                <img 
                  src={t.techSpecs.image} 
                  alt="Состав панелей GIPSOVINIL.KZ" 
                  className="max-w-full h-auto max-h-80 object-contain"
                />
              </div>
              <div className="space-y-4">
                {t.innovation.features.map((feature, idx) => (
                  <div key={idx} className="flex items-start space-x-3">
                    <CheckCircle2 className="w-6 h-6 text-[#061d36] flex-shrink-0 mt-1" />
                    <span className="text-[#061d36]/80">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Presentation Slides */}
      <section className="bg-[#F5F5F0]">
        <img 
          src={`${API_URL}/api/slides/7`} 
          alt={t.slides.slide7title}
          className="w-full h-auto"
          data-testid="slide-7-block"
        />
      </section>

      {/* Slide 11 - full width dark blue */}
      <section className="bg-[#061d36]" data-testid="slide-11-block">
        <img 
          src={`${API_URL}/api/slides/11`} 
          alt={t.slides.slide11title}
          className="w-full h-auto"
        />
      </section>

      {/* Slide 10 - full width dark blue */}
      <section className="bg-[#061d36]" data-testid="slide-10-block">
        <img 
          src={`${API_URL}/api/slides/10`} 
          alt={t.slides.slide10title}
          className="w-full h-auto"
        />
      </section>

      {/* CTA Section */}
      <section className="py-8 pb-16 bg-[#061d36] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{t.cta.title}</h2>
          <p className="text-blue-200 mb-8 max-w-2xl mx-auto">
            {t.cta.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              data-testid="cta-consultation-btn"
              className="px-8 py-4 bg-gradient-to-r from-[#8B4444] to-[#9B5555] hover:from-[#7A3838] hover:to-[#8A4848] text-white rounded-lg font-semibold transition-all shadow-lg"
            >
              {t.cta.consultation}
            </Link>
            <Link
              to="/catalog"
              data-testid="cta-catalog-btn"
              className="px-8 py-4 bg-transparent border-2 border-white/30 hover:border-white/50 hover:bg-white/5 text-white rounded-lg font-semibold transition-all"
            >
              {t.cta.catalog}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;
